import $ from 'jquery'
import {Core} from './core'

export class TableContent {

  constructor() {
    if (Core.isAdmin()) return

    this.$document = $(document)
    this.$window = $(window)
    this.$body = $('body')
    this.$tableContent = $('.table-content');
    this.$wrapper = this.$tableContent.parents('.single-reading-time-main.with-table');

    this.handleScrollUpdateLinks()

    this.$tableContent.find('a').on('click', this.handleLinkClick.bind(this));
    this.$window.on('scroll', this.handleScrollUpdateLinks.bind(this))
  }

  handleLinkClick(ev) {
    const $currentLink = $(ev.currentTarget);
    const $links = this.$tableContent.find('a');
    const $currentSection = $($currentLink.attr('href'));
    setTimeout(() => {
      $links.removeClass('active');
      $currentLink.addClass('active');
      $currentSection.parents().find('section').removeClass('active');
      $currentSection.addClass('active');
    }, 400);
  }

  handleScrollUpdateLinks() {
    if (this.$tableContent.length === 0) return

    let $links = this.$tableContent.find('a')
    if ($links.length === 0) return

    let $currentLink = false
    let $currentSection = false;
    const $sections = this.$wrapper.find('.single-reading-time-content section');

    $links.each((index, link) => {
      let $link = $(link)

      let $section = $($link.attr('href'))
      if ($section.length === 0) return

      let itemTop = $section.offset().top
      let itemBottom = itemTop + $section.outerHeight()
      let windowTop = this.$window.scrollTop() + $('.header').outerHeight() + 50

      if (windowTop > itemTop && windowTop < itemBottom) {
        $currentLink = $link;
        $currentSection = $section;
      }
    })

    if (!$currentLink) return

    $sections.removeClass('active');
    $currentSection.addClass('active');
    $links.removeClass('active')
    $currentLink.addClass('active')
  }
}
